import Inquiry from "./inquiry"
import Layout from "./layout"

export default class {
  /**
   * @returns {void}
   */
  constructor() {
    new Layout()
    new Inquiry()
  }
}
